// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"457":"6900a50ca1ebf1345191","541":"324c4e83cfde5556e578","940":"5b3d5f36a03bc8d54e41"}[chunkId] + ".css";
};